import $ from 'jquery';

export default () => {
    const navArrows = [
        '<svg width="20" height="13" viewBox="0 0 20 13" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.35754 12.3072C6.74805 12.6977 7.38123 12.6977 7.77173 12.3072C8.16223 11.9167 8.16223 11.2835 7.77173 10.893L4.47876 7.60007L18.0646 7.60007C18.6168 7.60007 19.0646 7.15234 19.0646 6.60007C19.0646 6.04779 18.6168 5.60007 18.0646 5.60007L4.47876 5.60007L7.77173 2.30716C8.16223 1.91666 8.16223 1.28348 7.77173 0.892975C7.38123 0.502472 6.74805 0.502472 6.35754 0.892975L1.36426 5.88617C1.35974 5.89066 1.35522 5.89517 1.35071 5.89975L0.650391 6.60007L1.35071 7.30038C1.35522 7.30496 1.35974 7.30948 1.36426 7.31396L6.35754 12.3072Z"/> </svg>',
        '<svg width="20" height="13" viewBox="0 0 20 13" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3574 0.893005C12.9669 0.502471 12.3337 0.502471 11.9432 0.893005C11.5527 1.28351 11.5527 1.91669 11.9432 2.30719L15.2362 5.6001L1.65039 5.6001C1.09815 5.6001 0.650391 6.04782 0.650391 6.6001C0.650391 7.15237 1.09814 7.6001 1.65039 7.6001L15.2362 7.6001L11.9432 10.893C11.5527 11.2835 11.5527 11.9167 11.9432 12.3072C12.3337 12.6977 12.9669 12.6977 13.3574 12.3072L18.3507 7.314C18.3552 7.30951 18.3597 7.30499 18.3643 7.30041L19.0646 6.6001L18.3643 5.89978C18.3597 5.8952 18.3552 5.89069 18.3507 5.8862L13.3574 0.893005Z"/> </svg>'
    ];

    $('.js-media-centre-card-carousel').each(function() {
        $(this).owlCarousel({
            autoplay: false,
            autoplayHoverPause: false,
            items: 1,
            margin: 10,
            nav: true,
            navText: navArrows,
            navContainer: $(this).parent().find('.js-media-centre-card-carousel-nav'),
            dots: true,
            dotsContainer: $(this).parent().find('.js-media-centre-card-carousel-dots'),
            dotsEach: true,
            slideTransition : 'cubic-bezier(.64,.07,.7,.65)',
            responsive: {
                768: {
                    items: 2,
                    margin: 24,
                },
                1028: {
                    items: 3,
                    margin: 24,
                }
            }
        });
    });
}
